module.exports = __webpack_public_path__ + "img/halloween-castle-1.9752e7bf.svg";